<template lang="html">
  <button class="button-remove" @click.stop.prevent="click">
    <v-icon name="close" />
  </button>
</template>

<script>
export default {
  methods: {
    click() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss">
button.button-remove {
  position: absolute;
  top: 0;
  right: 0;
  line-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  background: gray(500);
  color: white;
  border-radius: 50%;
  font-size: 14px;
  padding: 0 !important;
  font-weight: 300;
  border: 2px solid #fff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/parts/modules/button-remove.vue